
import PaymentMethod from '../pages/Inside/Contract/paymentsMethod.jsx'
import NewLogin from '../pages/NewLogin.jsx';
import Nregistro from '../pages/registro.jsx';
import HomePage from '../pages/home.jsx';
import Nregistro2 from '../pages/registro2.jsx';
import changePass from '../pages/Npass.jsx';
import InsideApp from '../pages/Inside/inside2.jsx';

var routes = [{
        path: '/',
        component: NewLogin
    },
    {
        path: '/HomeInsdide/',
        component: InsideApp
    },
    {
        path: '/Payment/',
        component: PaymentMethod
    },
    
    {
        path: '/Register',
        component: Nregistro
    },
    {
        path:'/Validate',
        component:changePass
    },
    {
        path: '/registro2/',
        component: Nregistro2
      }
      

   

    
    
];

export default routes;